export default "__VITE_ASSET__612848bc__"